import { HOW_IT_WORKS_VIEW, HOW_IT_WORKS_SLIDE_CHANGE, WATCH_HOW_IT_WORKS_VIEW } from './types';

export const triggerHowItWorksIsViewed = userIsIdentified => ({
  type: HOW_IT_WORKS_VIEW,
  userIsIdentified,
});

export const triggerHowItWorksIsSwiped = slideIndex => ({
  type: HOW_IT_WORKS_SLIDE_CHANGE,
  slideIndex,
});

export const triggerWatchHowItWorksIsViewed = () => ({
  type: WATCH_HOW_IT_WORKS_VIEW,
});
